import React, { useState } from 'react';
import Icon from './Icon';

const ClientHelpContent = () => {
  const [activeSection, setActiveSection] = useState(null);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const navbarHeight = 80; // Height of top navbar
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - navbarHeight;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      setActiveSection(sectionId);
    }
  };

  return (
    <div className="flex gap-8">
      {/* Left Sidebar - Table of Contents */}
      <aside className="hidden lg:block w-64 flex-shrink-0">
        <div className="sticky top-24">
          <div className="bg-white rounded-lg shadow-sm border border-neutral-200 p-6">
            <h2 className="text-lg font-semibold text-primary mb-4 flex items-center gap-2">
              <Icon name="list" size={20} className="text-brand-primary-600" />
              Innehåll
            </h2>
            <nav className="space-y-2">
              {/* 1. Välkommen */}
              <button
                onClick={() => scrollToSection('welcome')}
                className={`w-full text-left px-3 py-2 rounded-lg hover:bg-brand-primary-50 transition-colors ${
                  activeSection === 'welcome' ? 'bg-brand-primary-100 text-brand-primary-700' : 'text-secondary'
                }`}
              >
                <div className="flex items-center gap-2">
                  <Icon name="heart" size={14} className="text-brand-primary-600" />
                  <span className="text-sm">Välkommen</span>
                </div>
              </button>

              {/* 2. Komma igång med livsteman */}
              <button
                onClick={() => scrollToSection('getting-started-themes')}
                className={`w-full text-left px-3 py-2 rounded-lg hover:bg-brand-primary-50 transition-colors ${
                  activeSection === 'getting-started-themes' ? 'bg-brand-primary-100 text-brand-primary-700' : 'text-secondary'
                }`}
              >
                <div className="flex items-center gap-2">
                  <Icon name="compass" size={14} className="text-brand-primary-600" />
                  <span className="text-sm">Komma igång</span>
                </div>
              </button>

              {/* 3. Utforska med AI */}
              <button
                onClick={() => scrollToSection('ai-exploration')}
                className={`w-full text-left px-3 py-2 rounded-lg hover:bg-brand-primary-50 transition-colors ${
                  activeSection === 'ai-exploration' ? 'bg-brand-primary-100 text-brand-primary-700' : 'text-secondary'
                }`}
              >
                <div className="flex items-center gap-2">
                  <Icon name="message-circle-heart" size={14} className="text-brand-primary-600" />
                  <span className="text-sm">AI-utforskning</span>
                </div>
              </button>

              {/* 4. Köpa credits */}
              <button
                onClick={() => scrollToSection('credits')}
                className={`w-full text-left px-3 py-2 rounded-lg hover:bg-brand-primary-50 transition-colors ${
                  activeSection === 'credits' ? 'bg-brand-primary-100 text-brand-primary-700' : 'text-secondary'
                }`}
              >
                <div className="flex items-center gap-2">
                  <Icon name="credit-card" size={14} className="text-brand-primary-600" />
                  <span className="text-sm">Köpa credits</span>
                </div>
              </button>

              {/* 5. Hitta psykoterapeut */}
              <button
                onClick={() => scrollToSection('find-therapist')}
                className={`w-full text-left px-3 py-2 rounded-lg hover:bg-brand-primary-50 transition-colors ${
                  activeSection === 'find-therapist' ? 'bg-brand-primary-100 text-brand-primary-700' : 'text-secondary'
                }`}
              >
                <div className="flex items-center gap-2">
                  <Icon name="users" size={14} className="text-brand-primary-600" />
                  <span className="text-sm">Hitta terapeut</span>
                </div>
              </button>

              {/* 6. Säkerhet och integritet */}
              <button
                onClick={() => scrollToSection('security-privacy')}
                className={`w-full text-left px-3 py-2 rounded-lg hover:bg-brand-primary-50 transition-colors ${
                  activeSection === 'security-privacy' ? 'bg-brand-primary-100 text-brand-primary-700' : 'text-secondary'
                }`}
              >
                <div className="flex items-center gap-2">
                  <Icon name="shield" size={14} className="text-success-600" />
                  <span className="text-sm">Säkerhet</span>
                </div>
              </button>

              {/* 7. Teknisk hjälp */}
              <button
                onClick={() => scrollToSection('technical-help')}
                className={`w-full text-left px-3 py-2 rounded-lg hover:bg-brand-primary-50 transition-colors ${
                  activeSection === 'technical-help' ? 'bg-brand-primary-100 text-brand-primary-700' : 'text-secondary'
                }`}
              >
                <div className="flex items-center gap-2">
                  <Icon name="settings" size={14} className="text-brand-primary-600" />
                  <span className="text-sm">Teknisk hjälp</span>
                </div>
              </button>

              {/* 8. Vanliga frågor */}
              <button
                onClick={() => scrollToSection('faq')}
                className={`w-full text-left px-3 py-2 rounded-lg hover:bg-brand-primary-50 transition-colors ${
                  activeSection === 'faq' ? 'bg-brand-primary-100 text-brand-primary-700' : 'text-secondary'
                }`}
              >
                <div className="flex items-center gap-2">
                  <Icon name="help-circle" size={14} className="text-brand-primary-600" />
                  <span className="text-sm">Vanliga frågor</span>
                </div>
              </button>

              {/* 9. Om tjänsten */}
              <button
                onClick={() => scrollToSection('about-service')}
                className={`w-full text-left px-3 py-2 rounded-lg hover:bg-brand-primary-50 transition-colors ${
                  activeSection === 'about-service' ? 'bg-brand-primary-100 text-brand-primary-700' : 'text-secondary'
                }`}
              >
                <div className="flex items-center gap-2">
                  <Icon name="info" size={14} className="text-brand-primary-600" />
                  <span className="text-sm">Om tjänsten</span>
                </div>
              </button>

              {/* 10. Kontakta oss */}
              <button
                onClick={() => scrollToSection('contact')}
                className={`w-full text-left px-3 py-2 rounded-lg hover:bg-brand-primary-50 transition-colors ${
                  activeSection === 'contact' ? 'bg-brand-primary-100 text-brand-primary-700' : 'text-secondary'
                }`}
              >
                <div className="flex items-center gap-2">
                  <Icon name="mail" size={14} className="text-brand-primary-600" />
                  <span className="text-sm">Kontakta oss</span>
                </div>
              </button>
            </nav>
          </div>
        </div>
      </aside>

      {/* Main Content */}
      <div className="flex-1 space-y-8 min-w-0">
        {/* Section 1: Welcome */}
        <div id="welcome" className="bg-white rounded-lg shadow-sm border border-neutral-200 p-6">
          <h2 className="text-2xl font-bold text-primary mb-6 flex items-center gap-2">
            <Icon name="heart" size={28} className="text-brand-primary-600" />
            1. Välkommen till Your Therapist
          </h2>
          
          <div className="space-y-6">
            <div className="bg-gradient-to-r from-brand-primary-50 to-brand-primary-100 p-6 rounded-lg border border-brand-primary-200">
              <h3 className="text-lg font-semibold text-primary mb-3">Vad är vår tjänst?</h3>
              <p className="text-secondary leading-relaxed mb-4">
                Your Therapist är en modern plattform för självhjälp och personlig utveckling genom schematerapi. 
                Vi kombinerar vetenskapligt beprövade metoder med AI-teknologi för att ge dig verktyg att utforska 
                och förstå dina djupaste livsmönster – de så kallade livsteman.
              </p>
              <p className="text-secondary leading-relaxed">
                Vår tjänst är byggd på Jeffrey Youngs schematerapi, en etablerad terapiform som hjälper människor 
                att identifiera och arbeta med känslomässiga mönster som formats tidigt i livet.
              </p>
            </div>

            <div className="bg-warning-50 border-l-4 border-warning-600 p-6 rounded-r-lg">
              <h3 className="text-lg font-semibold text-warning-800 mb-3 flex items-center gap-2">
                <Icon name="alert-triangle" size={20} />
                Detta är INTE psykoterapi - viktigt att veta
              </h3>
              <div className="space-y-2 text-warning-700">
                <p className="font-medium">Vår tjänst är ett verktyg för självhjälp och personlig utveckling, inte professionell terapi.</p>
                <ul className="list-disc list-inside space-y-1 ml-4">
                  <li>Vi ersätter inte behandling av psykisk ohälsa</li>
                  <li>Vi ställer inga diagnoser eller ordinerar behandling</li>
                  <li>AI:n kan inte ersätta en legitimerad psykoterapeut</li>
                  <li>Vid allvarliga symtom - sök professionell hjälp</li>
                </ul>
              </div>
            </div>

            <div className="bg-info-50 border border-info-300 p-6 rounded-lg">
              <h3 className="text-lg font-semibold text-info-800 mb-3 flex items-center gap-2">
                <Icon name="heart" size={20} />
                Självhjälp med AI-stöd
              </h3>
              <p className="text-info-700 leading-relaxed mb-4">
                Vår AI-assistent är tränad i schematerapi och kan hjälpa dig att:
              </p>
              <div className="grid md:grid-cols-2 gap-4">
                <div className="bg-white p-4 rounded-lg">
                  <p className="text-sm text-secondary flex items-start gap-2">
                    <Icon name="check" size={16} className="text-success-600 mt-1 flex-shrink-0" />
                    <span>Identifiera dina livsteman genom självskattning</span>
                  </p>
                </div>
                <div className="bg-white p-4 rounded-lg">
                  <p className="text-sm text-secondary flex items-start gap-2">
                    <Icon name="check" size={16} className="text-success-600 mt-1 flex-shrink-0" />
                    <span>Utforska ursprung och konsekvenser av dina mönster</span>
                  </p>
                </div>
                <div className="bg-white p-4 rounded-lg">
                  <p className="text-sm text-secondary flex items-start gap-2">
                    <Icon name="check" size={16} className="text-success-600 mt-1 flex-shrink-0" />
                    <span>Utveckla strategier för hälsosammare beteenden</span>
                  </p>
                </div>
                <div className="bg-white p-4 rounded-lg">
                  <p className="text-sm text-secondary flex items-start gap-2">
                    <Icon name="check" size={16} className="text-success-600 mt-1 flex-shrink-0" />
                    <span>Få stöd mellan terapisessioner (om du har terapeut)</span>
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-r from-success-50 to-success-100 p-6 rounded-lg border border-success-300">
              <h3 className="text-lg font-semibold text-success-800 mb-3">Men - vi har psykoterapeuter du alltid kan kontakta</h3>
              <p className="text-success-700 leading-relaxed mb-3">
                Om du under din självskattnig eller AI-utforskning upptäcker att du behöver professionell hjälp, 
                kan du enkelt ansluta till en av våra legitimerade psykoterapeuter.
              </p>
              <p className="text-success-700 leading-relaxed">
                De kan erbjuda riktig terapi, ställa diagnoser och ge dig den professionella vård du behöver.
              </p>
            </div>
          </div>
        </div>      <div id="getting-started-themes" className="bg-white rounded-lg shadow-sm border border-neutral-200 p-6">
          <h2 className="text-2xl font-bold text-primary mb-6 flex items-center gap-2">
            <Icon name="clipboard" size={28} className="text-brand-primary-600" />
            2. Komma igång med livsteman
          </h2>
          
          <div className="space-y-6">
            <div className="bg-gradient-to-r from-brand-primary-50 to-brand-secondary-50 p-6 rounded-lg border border-brand-primary-200">
              <h3 className="text-lg font-semibold text-primary mb-3">Vad är livsteman?</h3>
              <p className="text-secondary leading-relaxed mb-3">
                Livsteman (även kallade "scheman") är djupa emotionella mönster som formats tidigt i livet, 
                ofta under barndomen. De påverkar hur vi tänker, känner och agerar som vuxna - särskilt i 
                stressiga situationer eller nära relationer.
              </p>
              <div className="bg-white p-4 rounded-lg">
                <p className="text-sm text-secondary">
                  <strong>Exempel:</strong> Om du som barn ofta kände dig övergiven kan temat "Övergivenhet/Instabilitet" 
                  göra att du som vuxen oroar dig mycket för att människor ska lämna dig, även när det inte finns 
                  någon verklig anledning.
                </p>
              </div>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-primary mb-4">Så fungerar självskattningen</h3>
              
              <div className="space-y-4">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-brand-primary-100 text-brand-primary-700 rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0">1</div>
                  <div className="flex-1">
                    <h4 className="font-semibold text-primary mb-2">20 livsteman</h4>
                    <p className="text-sm text-secondary">Vi mäter 20 olika livsteman baserade på Jeffrey Youngs forskning, allt från "Känslomässig deprivation" till "Orealistiska krav".</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-brand-primary-100 text-brand-primary-700 rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0">2</div>
                  <div className="flex-1">
                    <h4 className="font-semibold text-primary mb-2">116 frågor</h4>
                    <p className="text-sm text-secondary">Du besvarar 116 påståenden som beskriver tankar, känslor och beteenden. Ta din tid - det är viktigt att svara ärligt.</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-brand-primary-100 text-brand-primary-700 rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0">3</div>
                  <div className="flex-1">
                    <h4 className="font-semibold text-primary mb-2">Skala 1-6</h4>
                    <p className="text-sm text-secondary mb-2">För varje påstående markerar du hur väl det stämmer in på dig:</p>
                    <div className="bg-neutral-50 p-3 rounded-lg text-xs text-secondary space-y-1">
                      <p>1 = Stämmer inte alls</p>
                      <p>2 = Stämmer mest inte</p>
                      <p>3 = Stämmer mer falskt än sant</p>
                      <p>4 = Stämmer mer sant än falskt</p>
                      <p>5 = Stämmer oftast</p>
                      <p>6 = Stämmer helt och hållet</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-info-50 border border-info-300 p-6 rounded-lg">
              <h3 className="text-lg font-semibold text-info-800 mb-3">Hur tolkar jag mina resultat?</h3>
              <div className="space-y-3">
                <div>
                  <p className="text-sm font-medium text-info-800 mb-2">Färgkodning baserad på median:</p>
                  <div className="space-y-2">
                    <div className="flex items-center gap-3">
                      <div className="w-6 h-6 bg-success-500 rounded"></div>
                      <span className="text-sm text-info-700"><strong>Grön:</strong> Låg poäng - temat påverkar dig lite eller inte alls</span>
                    </div>
                    <div className="flex items-center gap-3">
                      <div className="w-6 h-6 bg-yellow-400 rounded"></div>
                      <span className="text-sm text-info-700"><strong>Gul:</strong> Medelhög poäng - temat påverkar dig ibland</span>
                    </div>
                    <div className="flex items-center gap-3">
                      <div className="w-6 h-6 bg-red-500 rounded"></div>
                      <span className="text-sm text-info-700"><strong>Röd:</strong> Hög poäng - temat påverkar dig kraftigt i vardagen</span>
                    </div>
                  </div>
                </div>
                
                <div className="bg-white p-4 rounded-lg mt-3">
                  <p className="text-xs text-secondary">
                    <strong>Tips:</strong> Fokusera först på de röda och gula temana - de ger störst potential för förändring!
                  </p>
                </div>
              </div>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-primary mb-4">Navigera i frågorna</h3>
              <div className="bg-neutral-50 p-5 rounded-lg border border-neutral-200">
                <div className="grid md:grid-cols-2 gap-4">
                  <div>
                    <h4 className="font-medium text-primary mb-2 text-sm flex items-center gap-2">
                      Karusell-navigation
                    </h4>
                    <p className="text-xs text-secondary">
                      Frågorna visas som ett snurrande hjul där du kan se flera frågor samtidigt. 
                      Klicka på en fråga för att besvara den, eller använd pilknapparna.
                    </p>
                  </div>
                  
                  <div>
                    <h4 className="font-medium text-primary mb-2 text-sm flex items-center gap-2">
                      Spara och fortsätt senare
                    </h4>
                    <p className="text-xs text-secondary">
                      Du kan när som helst pausa och komma tillbaka - dina svar sparas automatiskt. 
                      Ta gärna en paus om du blir trött!
                    </p>
                  </div>
                  
                  <div>
                    <h4 className="font-medium text-primary mb-2 text-sm flex items-center gap-2">
                      Översikt
                    </h4>
                    <p className="text-xs text-secondary">
                      Klicka på "Översikt" för att se alla frågor i en lista och enkelt hoppa mellan dem.
                    </p>
                  </div>
                  
                  <div>
                    <h4 className="font-medium text-primary mb-2 text-sm flex items-center gap-2">
                      Progressindikator
                    </h4>
                    <p className="text-xs text-secondary">
                      En cirkelformad indikator visar hur många frågor du har besvarat (t.ex. "43/116").
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-warning-50 border-l-4 border-warning-600 p-5 rounded-r-lg">
              <h3 className="text-lg font-semibold text-warning-800 mb-3">Tips för bästa resultat</h3>
              <ul className="space-y-2 text-sm text-warning-700">
                <li className="flex items-start gap-2">
                  <Icon name="check" size={16} className="text-warning-600 mt-1 flex-shrink-0" />
                  <span><strong>Svara ärligt</strong> - det finns inga "rätta" eller "fel" svar</span>
                </li>
                <li className="flex items-start gap-2">
                  <Icon name="check" size={16} className="text-warning-600 mt-1 flex-shrink-0" />
                  <span><strong>Tänk på hur du oftast känner</strong> - inte bara just nu</span>
                </li>
                <li className="flex items-start gap-2">
                  <Icon name="check" size={16} className="text-warning-600 mt-1 flex-shrink-0" />
                  <span><strong>Ta din tid</strong> - det är bättre att göra det noggrant än snabbt</span>
                </li>
                <li className="flex items-start gap-2">
                  <Icon name="check" size={16} className="text-warning-600 mt-1 flex-shrink-0" />
                  <span><strong>Ta en paus</strong> om du blir emotionellt berörd - det är normalt</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div id="ai-exploration" className="bg-white rounded-lg shadow-sm border border-neutral-200 p-6">
          <h2 className="text-2xl font-bold text-primary mb-6 flex items-center gap-2">
            <Icon name="message-circle-heart" size={28} className="text-brand-primary-600" />
            3. Utforska dina livsteman med AI
          </h2>
          
          <div className="space-y-6">
            <div className="bg-gradient-to-r from-brand-primary-50 to-brand-tertiary-50 p-6 rounded-lg border border-brand-primary-200">
              <h3 className="text-lg font-semibold text-primary mb-3">Hur AI-chatten fungerar</h3>
              <p className="text-secondary leading-relaxed mb-4">
                Vår AI-assistent är specialtränad i schematerapi och Jeffrey Youngs metodik. Den använder dina 
                livstemaresultat som grund för att hjälpa dig utforska dina mönster djupare genom samtal.
              </p>
              <p className="text-secondary leading-relaxed">
                AI:n kombinerar dina svar på livstemafrågorna med information du delar i samtalen för att ge 
                personliga insikter och vägledning i ditt förändringsarbete.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-primary mb-4">Vad AI kan hjälpa dig med</h3>
              
              <div className="space-y-4">
                <div className="bg-white border border-neutral-200 p-5 rounded-lg">
                  <h4 className="font-semibold text-primary mb-3 flex items-center gap-2">
                    <Icon name="search" size={18} className="text-brand-primary-600" />
                    1. Identifiera mönster i tankar och beteenden
                  </h4>
                  <p className="text-sm text-secondary mb-3">
                    AI:n hjälper dig se samband mellan dina livsteman och hur du reagerar i vardagssituationer.
                  </p>
                  <div className="bg-neutral-50 p-3 rounded text-xs text-secondary italic">
                    "Jag blir alltid arg när min partner är sen..." → AI hjälper dig se kopplingen till 
                    ett övergivenhetsschema och tidigare upplevelser.
                  </div>
                </div>

                <div className="bg-white border border-neutral-200 p-5 rounded-lg">
                  <h4 className="font-semibold text-primary mb-3 flex items-center gap-2">
                    <Icon name="layers" size={18} className="text-brand-primary-600" />
                    2. Utforska ursprung och konsekvenser
                  </h4>
                  <p className="text-sm text-secondary mb-3">
                    Förstå var dina livsteman kommer ifrån och hur de påverkar ditt liv idag.
                  </p>
                  <ul className="space-y-1 text-xs text-secondary ml-4">
                    <li>• Barndomsupplevelser som format mönstren</li>
                    <li>• Hur temat aktiveras i nutida relationer</li>
                    <li>• Konsekvenser i arbete, relationer och självkänsla</li>
                  </ul>
                </div>

                <div className="bg-white border border-neutral-200 p-5 rounded-lg">
                  <h4 className="font-semibold text-primary mb-3 flex items-center gap-2">
                    <Icon name="target" size={18} className="text-brand-primary-600" />
                    3. Utveckla strategier för förändring
                  </h4>
                  <p className="text-sm text-secondary mb-3">
                    AI:n guidar dig genom konkreta övningar och strategier baserade på schematerapi.
                  </p>
                  <div className="grid md:grid-cols-2 gap-2">
                    <div className="bg-success-50 p-2 rounded text-xs">
                      <strong>Kognitiva tekniker:</strong> Ifrågasätt dysfunktionella tankar
                    </div>
                    <div className="bg-success-50 p-2 rounded text-xs">
                      <strong>Beteendeövningar:</strong> Bryt destruktiva mönster
                    </div>
                    <div className="bg-success-50 p-2 rounded text-xs">
                      <strong>Emotionellt arbete:</strong> Bearbeta känslor kopplade till scheman
                    </div>
                    <div className="bg-success-50 p-2 rounded text-xs">
                      <strong>Relationsarbete:</strong> Förändra interaktionsmönster
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-warning-50 border-l-4 border-warning-600 p-6 rounded-r-lg">
              <h3 className="text-lg font-semibold text-warning-800 mb-3 flex items-center gap-2">
                <Icon name="alert-triangle" size={20} />
                AI:ns begränsningar - när du behöver professionell hjälp
              </h3>
              <div className="space-y-3">
                <p className="text-sm text-warning-700">
                  AI är ett kraftfullt verktyg för självreflektion och utveckling, men det finns situationer 
                  där du behöver kontakta en legitimerad terapeut:
                </p>
                <ul className="space-y-2 text-sm text-warning-700 ml-4">
                  <li className="flex items-start gap-2">
                    <Icon name="alert-circle" size={16} className="text-warning-600 mt-1 flex-shrink-0" />
                    <span><strong>Självmordstankar eller självskadebeteende</strong> - Ring 112 eller Självmordslinjen 90101</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <Icon name="alert-circle" size={16} className="text-warning-600 mt-1 flex-shrink-0" />
                    <span><strong>Allvarlig depression eller ångest</strong> - Sök professionell bedömning</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <Icon name="alert-circle" size={16} className="text-warning-600 mt-1 flex-shrink-0" />
                    <span><strong>Trauma eller PTSD</strong> - Kräver specialiserad traumaterapi</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <Icon name="alert-circle" size={16} className="text-warning-600 mt-1 flex-shrink-0" />
                    <span><strong>Missbruksproblematik</strong> - Behöver strukturerad behandling</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <Icon name="alert-circle" size={16} className="text-warning-600 mt-1 flex-shrink-0" />
                    <span><strong>Komplext eller långvarigt lidande</strong> - En terapeut kan ge djupare stöd</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="bg-info-50 border border-info-300 p-6 rounded-lg">
              <h3 className="text-lg font-semibold text-info-800 mb-3">Så får du mest ut av AI-samtalen</h3>
              <div className="grid md:grid-cols-2 gap-4">
                <div className="bg-white p-4 rounded-lg">
                  <h4 className="font-medium text-primary mb-2 text-sm flex items-center gap-2">
                    <Icon name="check-circle" size={16} className="text-success-600" />
                    Var ärlig och öppen
                  </h4>
                  <p className="text-xs text-secondary">AI:n kan bara hjälpa dig om du delar dina verkliga tankar och känslor</p>
                </div>
                <div className="bg-white p-4 rounded-lg">
                  <h4 className="font-medium text-primary mb-2 text-sm flex items-center gap-2">
                    <Icon name="check-circle" size={16} className="text-success-600" />
                    Ge konkreta exempel
                  </h4>
                  <p className="text-xs text-secondary">Beskriv specifika situationer istället för att vara vag</p>
                </div>
                <div className="bg-white p-4 rounded-lg">
                  <h4 className="font-medium text-primary mb-2 text-sm flex items-center gap-2">
                    <Icon name="check-circle" size={16} className="text-success-600" />
                    Ställ följdfrågor
                  </h4>
                  <p className="text-xs text-secondary">Om något är oklart - fråga! AI:n kan förklara på olika sätt</p>
                </div>
                <div className="bg-white p-4 rounded-lg">
                  <h4 className="font-medium text-primary mb-2 text-sm flex items-center gap-2">
                    <Icon name="check-circle" size={16} className="text-success-600" />
                    Testa förslag i verkligheten
                  </h4>
                  <p className="text-xs text-secondary">Använd AI:ns strategier i ditt dagliga liv och rapportera tillbaka</p>
                </div>
              </div>
            </div>
          </div>
        </div>      <div id="credits" className="bg-white rounded-lg shadow-sm border border-neutral-200 p-6">
          <h2 className="text-2xl font-bold text-primary mb-6 flex items-center gap-2">
            <Icon name="credit-card" size={28} className="text-brand-primary-600" />
            4. Köpa credits för chattfunktionen
          </h2>
          
          <div className="space-y-6">
            <div className="bg-brand-primary-50 p-6 rounded-lg border border-brand-primary-200">
              <h3 className="text-lg font-semibold text-primary mb-3">Vad är credits?</h3>
              <p className="text-secondary leading-relaxed mb-3">
                Credits är den valuta du använder för att chatta med AI:n. Varje meddelande du skickar 
                kostar ett visst antal credits beroende på längden och komplexiteten.
              </p>
              <div className="bg-white p-4 rounded-lg">
                <p className="text-sm text-secondary mb-2"><strong>Obs!</strong> Självskattningen av livsteman är alltid gratis - du behöver bara credits för AI-chatten.</p>
              </div>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-primary mb-4">Så köper du credits</h3>
              
              <div className="space-y-4">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-brand-primary-100 text-brand-primary-700 rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0">1</div>
                  <div className="flex-1">
                    <h4 className="font-semibold text-primary mb-2">Gå till Credits</h4>
                    <p className="text-sm text-secondary">Klicka på "Credits" i menyn eller din profilikon för att se ditt creditsaldo.</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-brand-primary-100 text-brand-primary-700 rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0">2</div>
                  <div className="flex-1">
                    <h4 className="font-semibold text-primary mb-2">Välj paket</h4>
                    <p className="text-sm text-secondary mb-3">Vi erbjuder olika paket som passar olika behov.</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-brand-primary-100 text-brand-primary-700 rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0">3</div>
                  <div className="flex-1">
                    <h4 className="font-semibold text-primary mb-2">Säkra betalningar</h4>
                    <p className="text-sm text-secondary mb-3">Vi använder branschledande betalningslösningar för säkra transaktioner.</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-info-50 border border-info-300 p-6 rounded-lg">
              <h3 className="text-lg font-semibold text-info-800 mb-3">Hur länge gäller mina credits?</h3>
              <p className="text-sm text-info-700 mb-3">
                Credits du köper har ingen utgångsdatum - de finns kvar på ditt konto tills du använder dem.
              </p>
            </div>
          </div>
        </div>

      <div id="find-therapist" className="bg-white rounded-lg shadow-sm border border-neutral-200 p-6">
          <h2 className="text-2xl font-bold text-primary mb-6 flex items-center gap-2">
            <Icon name="users" size={28} className="text-brand-primary-600" />
            5. Hitta en psykoterapeut
          </h2>
          
          <div className="space-y-6">
            <div className="bg-warning-50 border-l-4 border-warning-600 p-6 rounded-r-lg">
              <h3 className="text-lg font-semibold text-warning-800 mb-3">När bör jag söka professionell hjälp?</h3>
              <p className="text-sm text-warning-700 mb-3">
                Självhjälp är värdefullt, men det finns situationer där du behöver professionell vägledning:
              </p>
              <ul className="space-y-2 text-sm text-warning-700">
                <li className="flex items-start gap-2">
                  <Icon name="check" size={16} className="text-warning-600 mt-1 flex-shrink-0" />
                  <span>När dina livsteman påverkar ditt dagliga liv kraftigt (många röda teman)</span>
                </li>
                <li className="flex items-start gap-2">
                  <Icon name="check" size={16} className="text-warning-600 mt-1 flex-shrink-0" />
                  <span>Om du har svårt att bryta mönster på egen hand</span>
                </li>
                <li className="flex items-start gap-2">
                  <Icon name="check" size={16} className="text-warning-600 mt-1 flex-shrink-0" />
                  <span>Vid komplexa trauman eller djupt rotade scheman</span>
                </li>
                <li className="flex items-start gap-2">
                  <Icon name="check" size={16} className="text-warning-600 mt-1 flex-shrink-0" />
                  <span>När du vill ha strukturerad, långsiktig förändring</span>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-primary mb-4">Boka tid med legitimerad psykoterapeut</h3>
              <div className="bg-gradient-to-r from-brand-primary-50 to-brand-tertiary-50 p-6 rounded-lg border border-brand-primary-200">
                <p className="text-secondary mb-4">
                  Alla våra terapeuter är legitimerade och specialiserade i schematerapi. De kan erbjuda:
                </p>
                <div className="grid md:grid-cols-2 gap-3 mb-4">
                  <div className="bg-white p-3 rounded-lg text-sm">
                    <Icon name="check-circle" size={16} className="text-success-600 inline mr-2" />
                    Professionell bedömning
                  </div>
                  <div className="bg-white p-3 rounded-lg text-sm">
                    <Icon name="check-circle" size={16} className="text-success-600 inline mr-2" />
                    Individualiserad behandlingsplan
                  </div>
                  <div className="bg-white p-3 rounded-lg text-sm">
                    <Icon name="check-circle" size={16} className="text-success-600 inline mr-2" />
                    Djupgående traumabearbetning
                  </div>
                  <div className="bg-white p-3 rounded-lg text-sm">
                    <Icon name="check-circle" size={16} className="text-success-600 inline mr-2" />
                    Långsiktig uppföljning
                  </div>
                </div>
                <div className="text-center">
                  <a 
                    href="/therapists" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 bg-brand-primary-600 hover:bg-brand-primary-700 text-white font-semibold px-6 py-3 rounded-lg transition-colors shadow-md hover:shadow-lg"
                  >
                    <Icon name="users" size={18} />
                    Möt våra terapeuter
                    <Icon name="external-link" size={16} />
                  </a>
                </div>
              </div>
            </div>

            <div className="bg-info-50 border border-info-300 p-6 rounded-lg">
              <h3 className="text-lg font-semibold text-info-800 mb-3">Skillnaden mellan AI-stöd och riktig terapi</h3>
              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <h4 className="font-medium text-info-800 mb-2 text-sm">AI-stöd (självhjälp)</h4>
                  <ul className="text-xs text-info-700 space-y-1">
                    <li>• Självskattning och reflektion</li>
                    <li>• Tillgängligt 24/7</li>
                    <li>• Generella strategier</li>
                    <li>• Komplement till terapi</li>
                  </ul>
                </div>
                <div>
                  <h4 className="font-medium text-info-800 mb-2 text-sm">Professionell terapi</h4>
                  <ul className="text-xs text-info-700 space-y-1">
                    <li>• Professionell bedömning</li>
                    <li>• Personlig relation</li>
                    <li>• Skräddarsydd behandling</li>
                    <li>• Djupare läkning</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

      <div id="security-privacy" className="bg-white rounded-lg shadow-sm border border-neutral-200 p-6">
          <h2 className="text-2xl font-bold text-primary mb-6 flex items-center gap-2">
            <Icon name="shield" size={28} className="text-success-600" />
            6. Säkerhet och integritet
          </h2>
          
          <div className="space-y-6">
            <div className="bg-gradient-to-r from-success-50 to-success-100 p-6 rounded-lg border border-success-300">
              <h3 className="text-lg font-semibold text-success-800 mb-3 flex items-center gap-2">
                <Icon name="lock" size={20} />
                Hur vi skyddar dina personuppgifter
              </h3>
              <p className="text-success-700 leading-relaxed">
                Din integritet och datasäkerhet är vår högsta prioritet. Alla dina personuppgifter och svar 
                på livstemafrågorna krypteras och lagras säkert enligt högsta säkerhetsstandard.
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-6">
              <div className="bg-white border border-neutral-200 p-5 rounded-lg">
                <h4 className="font-semibold text-primary mb-3 flex items-center gap-2">
                  <Icon name="shield-check" size={18} className="text-success-600" />
                  GDPR och datalagring
                </h4>
                <p className="text-sm text-secondary mb-3">
                  Vi följer EU:s dataskyddsförordning (GDPR) till punkt och pricka:
                </p>
                <ul className="text-xs text-secondary space-y-1">
                  <li>• Data lagras inom EU</li>
                  <li>• Tydliga samtycken vid registrering</li>
                  <li>• Rätt till radering av dina uppgifter</li>
                  <li>• Transparens i datahantering</li>
                </ul>
              </div>

              <div className="bg-white border border-neutral-200 p-5 rounded-lg">
                <h4 className="font-semibold text-primary mb-3 flex items-center gap-2">
                  <Icon name="key" size={18} className="text-success-600" />
                  Kryptering och datasäkerhet
                </h4>
                <p className="text-sm text-secondary mb-3">
                  All kommunikation och datalagring använder militärgrad kryptering:
                </p>
                <ul className="text-xs text-secondary space-y-1">
                  <li>• TLS 1.3 för överföring</li>
                  <li>• AES-256 för lagring</li>
                  <li>• Regelbundna säkerhetsgranskningar</li>
                  <li>• Tvåfaktorsautentisering tillgänglig</li>
                </ul>
              </div>
            </div>

            <div className="bg-info-50 border border-info-300 p-6 rounded-lg">
              <h3 className="text-lg font-semibold text-info-800 mb-3">Vem har tillgång till mina svar?</h3>
              <div className="space-y-3 text-sm text-info-700">
                <p className="font-medium">Endast följande har tillgång till dina livstemaresultat och AI-chattar:</p>
                <div className="bg-white p-4 rounded-lg">
                  <p className="mb-2"><strong>1. Du själv</strong> - full tillgång till alla dina data</p>
                  <p className="mb-2"><strong>2. Din anslutna terapeut</strong> (om du har en) - för att ge bättre vård</p>
                  <p><strong>3. Ingen annan</strong> - vi delar ALDRIG dina data med tredje part utan ditt uttryckliga samtycke</p>
                </div>
              </div>
            </div>

            <div className="bg-neutral-50 p-6 rounded-lg border border-neutral-200">
              <h3 className="text-lg font-semibold text-primary mb-3">Radera dina uppgifter</h3>
              <p className="text-sm text-secondary mb-3">
                Du har full kontroll över dina data och kan när som helst:
              </p>
              <ul className="text-sm text-secondary space-y-2">
                <li className="flex items-start gap-2">
                  <Icon name="check" size={16} className="text-brand-primary-600 mt-1 flex-shrink-0" />
                  <span>Exportera alla dina data i maskinläsbart format</span>
                </li>
                <li className="flex items-start gap-2">
                  <Icon name="check" size={16} className="text-brand-primary-600 mt-1 flex-shrink-0" />
                  <span>Radera specifika svar eller chattar</span>
                </li>
                <li className="flex items-start gap-2">
                  <Icon name="check" size={16} className="text-brand-primary-600 mt-1 flex-shrink-0" />
                  <span>Ta bort hela ditt konto permanent</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

      <div id="technical-help" className="bg-white rounded-lg shadow-sm border border-neutral-200 p-6">
          <h2 className="text-2xl font-bold text-primary mb-6 flex items-center gap-2">
            <Icon name="tool" size={28} className="text-brand-primary-600" />
            7. Teknisk hjälp och felsökning
          </h2>
          
          <div className="space-y-6">
            <div className="bg-neutral-50 p-6 rounded-lg border border-neutral-200">
              <h3 className="text-lg font-semibold text-primary mb-4">Vanliga tekniska problem</h3>
              
              <div className="space-y-4">
                <details className="bg-white p-4 rounded-lg border border-neutral-200">
                  <summary className="font-medium text-primary cursor-pointer flex items-center gap-2">
                    <Icon name="mail" size={16} />
                    Jag har inte fått verifieringsmailet
                  </summary>
                  <div className="mt-3 text-sm text-secondary space-y-2 pl-6">
                    <p>1. Kolla din skräppost/spam-mapp</p>
                    <p>2. Sök efter mail från "noreply@yourtherapist.se" i din inkorg</p>
                    <p>3. Klicka på "Skicka nytt verifieringsmail" på inloggningssidan</p>
                    <p>4. Kontrollera att du använt rätt e-postadress</p>
                  </div>
                </details>

                <details className="bg-white p-4 rounded-lg border border-neutral-200">
                  <summary className="font-medium text-primary cursor-pointer flex items-center gap-2">
                    <Icon name="key" size={16} />
                    Jag har glömt mitt lösenord
                  </summary>
                  <div className="mt-3 text-sm text-secondary space-y-2 pl-6">
                    <p>1. Gå till inloggningssidan</p>
                    <p>2. Klicka på "Glömt lösenord?"</p>
                    <p>3. Ange din e-postadress</p>
                    <p>4. Kolla din e-post efter återställningslänk</p>
                    <p>5. Följ instruktionerna för att skapa nytt lösenord</p>
                  </div>
                </details>

                <details className="bg-white p-4 rounded-lg border border-neutral-200">
                  <summary className="font-medium text-primary cursor-pointer flex items-center gap-2">
                    <Icon name="credit-card" size={16} />
                    Betalningen fungerar inte
                  </summary>
                  <div className="mt-3 text-sm text-secondary space-y-2 pl-6">
                    <p>1. Kontrollera att ditt kort inte är spärrat eller utgånget</p>
                    <p>2. Försök med en annan webbläsare</p>
                    <p>3. Rensa cookies och cache</p>
                    <p>4. Testa med en annan betalmetod</p>
                    <p>5. Kontakta support om problemet kvarstår</p>
                  </div>
                </details>

                <details className="bg-white p-4 rounded-lg border border-neutral-200">
                  <summary className="font-medium text-primary cursor-pointer flex items-center gap-2">
                    <Icon name="message-circle" size={16} />
                    AI-chatten svarar inte
                  </summary>
                  <div className="mt-3 text-sm text-secondary space-y-2 pl-6">
                    <p>1. Kontrollera att du har credits kvar</p>
                    <p>2. Ladda om sidan (Cmd/Ctrl + R)</p>
                    <p>3. Kolla din internetanslutning</p>
                    <p>4. Testa i ett inkognitofönster</p>
                    <p>5. Rensa webbläsarens cache</p>
                  </div>
                </details>
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-6">
              <div className="bg-info-50 border border-info-300 p-5 rounded-lg">
                <h4 className="font-semibold text-info-800 mb-3 flex items-center gap-2">
                  <Icon name="monitor" size={18} />
                  Webläsarstöd
                </h4>
                <p className="text-sm text-info-700 mb-3">Vi rekommenderar de senaste versionerna av:</p>
                <ul className="text-xs text-info-700 space-y-1">
                  <li>• Chrome (rekommenderas)</li>
                  <li>• Firefox</li>
                  <li>• Safari</li>
                  <li>• Edge</li>
                </ul>
              </div>

              <div className="bg-success-50 border border-success-300 p-5 rounded-lg">
                <h4 className="font-semibold text-success-800 mb-3 flex items-center gap-2">
                  <Icon name="smartphone" size={18} />
                  Mobil och surfplatta
                </h4>
                <p className="text-sm text-success-700 mb-3">Tjänsten fungerar på:</p>
                <ul className="text-xs text-success-700 space-y-1">
                  <li>• iPhone och iPad (iOS 14+)</li>
                  <li>• Android-telefoner och surfplattor</li>
                  <li>• Responsiv design för alla skärmstorlekar</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

      <div id="faq" className="bg-white rounded-lg shadow-sm border border-neutral-200 p-6">
          <h2 className="text-2xl font-bold text-primary mb-6 flex items-center gap-2">
            <Icon name="help-circle" size={28} className="text-brand-primary-600" />
            8. Vanliga frågor (FAQ)
          </h2>
          
          <div className="space-y-4">
            <details className="bg-neutral-50 p-5 rounded-lg border border-neutral-200">
              <summary className="font-semibold text-primary cursor-pointer">
                Kan AI:n ersätta en riktig terapeut?
              </summary>
              <div className="mt-4 text-sm text-secondary space-y-2">
                <p className="font-medium">Nej, AI:n är inte en ersättning för professionell terapi.</p>
                <p>
                  Vår AI-assistent är ett verktyg för självreflektion och självhjälp. Den kan hjälpa dig 
                  identifiera mönster och utforska dina tankar, men den kan inte:
                </p>
                <ul className="list-disc pl-5 space-y-1">
                  <li>Ställa medicinska diagnoser</li>
                  <li>Erbjuda terapeutisk behandling</li>
                  <li>Hantera akuta krissituationer</li>
                  <li>Ersätta den mänskliga relationen i terapi</li>
                </ul>
              </div>
            </details>

            <details className="bg-neutral-50 p-5 rounded-lg border border-neutral-200">
              <summary className="font-semibold text-primary cursor-pointer">
                Hur länge tar det att göra självskattningen?
              </summary>
              <div className="mt-4 text-sm text-secondary">
                <p>Självskattningen består av 116 frågor och tar mellan 20-30 minuter att genomföra. Du kan spara och fortsätta senare om du behöver en paus.</p>
              </div>
            </details>

            <details className="bg-neutral-50 p-5 rounded-lg border border-neutral-200">
              <summary className="font-semibold text-primary cursor-pointer">
                Måste jag svara på alla frågor?
              </summary>
              <div className="mt-4 text-sm text-secondary space-y-2">
                <p>
                  Nej, du behöver inte nödvändigtvis besvara samtliga frågor i alla livsteman. Om du märker att ett 
                  helt livstema känns helt irrelevant för dig eller inte alls stämmer in på din livssituation, kan du 
                  välja att hoppa över dessa frågor.
                </p>
                <p>
                  <strong>Tips:</strong> Algoritmen kan fortfarande ge dig värdefulla insikter även om du inte besvarat 
                  alla frågor. Dock gäller att ju fler frågor du besvarar inom de teman som känns relevanta, desto mer 
                  exakt blir din profil och de insikter du får.
                </p>
              </div>
            </details>

            <details className="bg-neutral-50 p-5 rounded-lg border border-neutral-200">
              <summary className="font-semibold text-primary cursor-pointer">
                Kan jag göra om självskattningen?
              </summary>
              <div className="mt-4 text-sm text-secondary">
                <p>
                  Ja! Du kan göra om självskattningen när som helst för att se hur dina livsteman förändras över tid. 
                  Vi rekommenderar att vänta minst 3-6 månader mellan självskattningarna för att se verklig förändring.
                </p>
              </div>
            </details>

            <details className="bg-neutral-50 p-5 rounded-lg border border-neutral-200">
              <summary className="font-semibold text-primary cursor-pointer">
                Vad betyder det om jag har många "röda" teman?
              </summary>
              <div className="mt-4 text-sm text-secondary space-y-2">
                <p>
                  Röda teman betyder att du har höga poäng på dessa livsteman, vilket tyder på att de påverkar 
                  ditt liv kraftigt just nu.
                </p>
                <p className="font-medium">Detta är inte något att skämmas för!</p>
                <p>
                  Många röda teman kan innebära att det är extra värdefullt för dig att arbeta med en legitimerad 
                  terapeut som kan ge dig stöd i att bearbeta dessa mönster.
                </p>
              </div>
            </details>

            <details className="bg-neutral-50 p-5 rounded-lg border border-neutral-200">
              <summary className="font-semibold text-primary cursor-pointer">
                Kostar det något att använda tjänsten?
              </summary>
              <div className="mt-4 text-sm text-secondary space-y-2">
                <p><strong>Gratis:</strong></p>
                <ul className="list-disc pl-5 space-y-1">
                  <li>Självskattning av alla 20 livsteman</li>
                  <li>Se dina resultat och insikter</li>
                  <li>Registrera konto</li>
                </ul>
                <p className="mt-3"><strong>Kostar credits:</strong></p>
                <ul className="list-disc pl-5 space-y-1">
                  <li>Chatta med AI:n om dina livsteman</li>
                  <li>Få fördjupad AI-analys</li>
                </ul>
              </div>
            </details>

            <details className="bg-neutral-50 p-5 rounded-lg border border-neutral-200">
              <summary className="font-semibold text-primary cursor-pointer">
                Är mina svar anonyma?
              </summary>
              <div className="mt-4 text-sm text-secondary">
                <p>
                  Dina svar är kopplade till ditt användarkonto och krypterade enligt högsta säkerhetsstandard. 
                  Vi delar ALDRIG dina personuppgifter eller svar med tredje part utan ditt samtycke. 
                  Endast du (och eventuell ansluten terapeut du väljer) har tillgång till dina svar.
                </p>
              </div>
            </details>
          </div>
        </div>

      <div id="about-service" className="bg-white rounded-lg shadow-sm border border-neutral-200 p-6">
          <h2 className="text-2xl font-bold text-primary mb-6 flex items-center gap-2">
            <Icon name="info" size={28} className="text-brand-primary-600" />
            9. Om tjänsten
          </h2>
          
          <div className="space-y-6">
            <div className="bg-gradient-to-r from-brand-primary-50 to-brand-tertiary-50 p-6 rounded-lg border border-brand-primary-200">
              <h3 className="text-lg font-semibold text-primary mb-3">Vetenskaplig grund: Schematerapi</h3>
              <p className="text-secondary mb-3">
                Vår tjänst bygger på <strong>schematerapi</strong>, en evidensbaserad terapiform utvecklad av 
                psykologen Jeffrey Young. Schematerapi kombinerar element från kognitiv beteendeterapi, 
                psykodynamisk teori och anknytningsteori.
              </p>
              <div className="bg-white p-4 rounded-lg">
                <p className="text-sm text-secondary mb-2">
                  <strong>Livsteman (scheman)</strong> är djupa mönster som bildas tidigt i livet, ofta från 
                  barndom och tonår, när viktiga emotionella behov inte uppfylls.
                </p>
              </div>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-primary mb-4">Utvecklat av legitimerade psykologer</h3>
              <div className="bg-neutral-50 p-5 rounded-lg border border-neutral-200">
                <p className="text-sm text-secondary mb-3">
                  Tjänsten har utvecklats i samarbete med legitimerade psykologer och psykoterapeuter 
                  specialiserade på schematerapi. Alla livstemaskalor och AI-modeller är baserade på:
                </p>
                <ul className="text-sm text-secondary space-y-2">
                  <li className="flex items-start gap-2">
                    <Icon name="check" size={16} className="text-success-600 mt-1 flex-shrink-0" />
                    <span>Validerade kliniska instrument (Young Schema Questionnaire)</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <Icon name="check" size={16} className="text-success-600 mt-1 flex-shrink-0" />
                    <span>Aktuell forskning inom schematerapi</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <Icon name="check" size={16} className="text-success-600 mt-1 flex-shrink-0" />
                    <span>Etiska riktlinjer för digitala hälsotjänster</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-6">
              <div className="bg-info-50 border border-info-300 p-5 rounded-lg">
                <h4 className="font-semibold text-info-800 mb-3">AI som komplement, inte ersättning</h4>
                <p className="text-sm text-info-700">
                  Vår AI-assistent är utformad för att stödja din självreflektion och personliga utveckling. 
                  Den ersätter INTE professionell terapi utan kan fungera som:
                </p>
                <ul className="text-xs text-info-700 mt-2 space-y-1">
                  <li>• Förberedelse inför terapi</li>
                  <li>• Komplement till pågående terapi</li>
                  <li>• Verktyg för självkännedom</li>
                </ul>
              </div>

              <div className="bg-warning-50 border border-warning-300 p-5 rounded-lg">
                <h4 className="font-semibold text-warning-800 mb-3">Begränsningar</h4>
                <p className="text-sm text-warning-700 mb-2">
                  Det är viktigt att veta vad tjänsten INTE kan göra:
                </p>
                <ul className="text-xs text-warning-700 space-y-1">
                  <li>• Ställa psykiatriska diagnoser</li>
                  <li>• Förskriva medicin</li>
                  <li>• Hantera akuta kriser</li>
                  <li>• Ersätta den terapeutiska relationen</li>
                </ul>
              </div>
            </div>

            <div className="bg-success-50 border-l-4 border-success-600 p-6 rounded-r-lg">
              <h3 className="text-lg font-semibold text-success-800 mb-3">Vår vision</h3>
              <p className="text-sm text-success-700">
                Vi vill göra evidensbaserad psykologisk kunskap tillgänglig för alla. Genom att kombinera 
                schematerapi med modern AI-teknologi kan vi hjälpa fler människor till ökad självförståelse 
                och personlig utveckling - samtidigt som vi alltid har legitimerade terapeuter tillgängliga 
                för dem som behöver mer stöd.
              </p>
            </div>
          </div>
        </div>

      <div id="contact" className="bg-white rounded-lg shadow-sm border border-neutral-200 p-6">
          <h2 className="text-2xl font-bold text-primary mb-6 flex items-center gap-2">
            <Icon name="mail" size={28} className="text-brand-primary-600" />
            10. Kontakt och support
          </h2>
          
          <div className="space-y-6">
            <div className="bg-gradient-to-r from-brand-primary-50 to-brand-secondary-50 p-6 rounded-lg border border-brand-primary-200">
              <h3 className="text-lg font-semibold text-primary mb-3">Vi är här för att hjälpa dig</h3>
              <p className="text-secondary">
                Oavsett om du har tekniska frågor, behöver hjälp med att komma igång, eller vill prata med 
                en legitimerad terapeut - vi finns här för dig.
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-6">
              <div className="bg-white border-2 border-brand-primary-200 p-6 rounded-lg hover:border-brand-primary-400 transition-colors">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-12 h-12 bg-brand-primary-100 rounded-full flex items-center justify-center">
                    <Icon name="headphones" size={24} className="text-brand-primary-600" />
                  </div>
                  <h4 className="font-semibold text-primary text-lg">Teknisk support</h4>
                </div>
                <p className="text-sm text-secondary mb-4">
                  Har du problem med inloggning, betalning eller tekniska frågor?
                </p>
                <a href="mailto:support@therapyai.se" className="text-brand-primary-600 hover:text-brand-primary-700 font-medium text-sm flex items-center gap-2">
                  <Icon name="mail" size={16} />
                  info@yourtherapist.se
                </a>
                <p className="text-xs text-secondary mt-2">Svarstid: Inom 24 timmar på vardagar</p>
              </div>

              <div className="bg-white border-2 border-success-200 p-6 rounded-lg hover:border-success-400 transition-colors">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-12 h-12 bg-success-100 rounded-full flex items-center justify-center">
                    <Icon name="user" size={24} className="text-success-600" />
                  </div>
                  <h4 className="font-semibold text-primary text-lg">Prata med terapeut</h4>
                </div>
                <p className="text-sm text-secondary mb-4">
                  Behöver du professionell vägledning eller vill boka en session?
                </p>
                <a href="mailto:terapeut@therapyai.se" className="text-success-600 hover:text-success-700 font-medium text-sm flex items-center gap-2">
                  <Icon name="mail" size={16} />
                  info@yourtherapist.se
                </a>
                <p className="text-xs text-secondary mt-2">Legitimerade psykoterapeuter</p>
              </div>
            </div>

            <div className="bg-danger-50 border-l-4 border-danger-600 p-6 rounded-r-lg">
              <h3 className="text-lg font-semibold text-danger-800 mb-3 flex items-center gap-2">
                <Icon name="alert-circle" size={20} />
                Akut kris?
              </h3>
              <p className="text-sm text-danger-700 mb-4">
                Om du befinner dig i en akut kris eller har självmordstankar, kontakta omedelbart:
              </p>
              <div className="bg-white p-4 rounded-lg space-y-2">
                <p className="text-sm font-semibold text-danger-800">
                  <Icon name="phone" size={16} className="inline mr-2" />
                  Mind Självmordslinjen: 90101
                </p>
                <p className="text-xs text-secondary">Tillgänglig dygnet runt, alla dagar</p>
                <p className="text-sm font-semibold text-danger-800 mt-3">
                  <Icon name="phone" size={16} className="inline mr-2" />
                  Akut sjukvård: 1177
                </p>
                <p className="text-xs text-secondary">Sjukvårdsrådgivning dygnet runt</p>
                <p className="text-sm font-semibold text-danger-800 mt-3">
                  <Icon name="phone" size={16} className="inline mr-2" />
                  Akut fara: 112
                </p>
              </div>
            </div>

            <div className="bg-neutral-50 p-6 rounded-lg border border-neutral-200">
              <h3 className="text-lg font-semibold text-primary mb-3">Feedback och förslag</h3>
              <p className="text-sm text-secondary mb-4">
                Vi värderar dina synpunkter! Hjälp oss att förbättra tjänsten genom att dela dina tankar, 
                idéer eller upplevelser.
              </p>
              <a href="mailto:feedback@therapyai.se" className="text-brand-primary-600 hover:text-brand-primary-700 font-medium text-sm flex items-center gap-2">
                <Icon name="mail" size={16} />
                info@yourtherapist.se
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientHelpContent;
